import React, { useState } from "react";
import api from "../utils/api";

const StatusToggle = ({ status, setStatus }) => {
  const [loading, setLoading] = useState(false);

  const toggleStatus = async () => {
    const newStatus = status === "online" ? "offline" : "online";
    setLoading(true);
    try {
      await api.post("/settings/restaurantstatus", { status: newStatus });
      setStatus(newStatus);
    } catch (error) {
      console.error("Failed to update status:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-2 md:gap-4 bg-gray-50 px-2 md:px-4 py-2 rounded-lg border border-gray-200">
      {/* Status Indicator */}
      <div className="flex items-center gap-1 md:gap-2">
        <div className="relative">
          <div
            className={`w-2 h-2 md:w-3 md:h-3 rounded-full ${status === "online" ? "bg-green-500" : "bg-red-500"}`}
          ></div>
          {status === "online" && (
            <div className="absolute inset-0 w-2 h-2 md:w-3 md:h-3 rounded-full bg-green-500 animate-ping opacity-75"></div>
          )}
        </div>
        <span className="font-text text-xs md:text-sm font-medium text-gray-700">
          Restaurant Status
        </span>
      </div>

      {/* Toggle Switch */}
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={status === "online"}
          onChange={toggleStatus}
          disabled={loading}
        />
        <div
          className={`
          w-10 md:w-14 h-5 md:h-7 bg-gray-300 rounded-full peer 
          peer-checked:bg-green-500 
          peer-focus:ring-4 peer-focus:ring-green-300
          after:content-[''] after:absolute after:top-0.5 after:left-[2px] md:after:left-[4px] 
          after:bg-white after:rounded-full after:h-4 after:w-4 md:after:h-6 md:after:w-6 
          after:transition-all after:shadow-md
          peer-checked:after:translate-x-full
          ${loading ? "opacity-50 cursor-not-allowed" : ""}
        `}
        ></div>
      </label>

      {/* Status Text */}
      <span
        className={`font-text text-xs md:text-sm font-semibold ${
          status === "online" ? "text-green-600" : "text-red-600"
        }`}
      >
        {status === "online" ? "On" : "Off"}
      </span>
    </div>
  );
};

export default StatusToggle;
